module.exports = __webpack_public_path__ + "img/angle-up.cd78fd92.svg";